import { type OptionItem, type WithOnChange } from "@common/declarations";
import { default as classNames, default as classnames } from "classnames";
import { identity } from "lodash";
import * as React from "react";

export type RadioOptionItem = OptionItem<any> & {
  className?: string;
  image?: string | null;
};

export type RadioButtonProps = Omit<RadioOptionItem, "label"> &
  Partial<WithOnChange<string>> & {
    addon?: any;
    className?: string;
    hideToggles?: boolean;
    id?: string;
    isChecked: boolean;
    isDisabled?: boolean;
    label?: string;
    name?: string;
    onBlur?: () => void;
    onFocus?: () => void;
    showLabel?: boolean;
    style?: React.CSSProperties;

    ImageComponent?: React.ComponentType<{ src: string | null }>;
  };

const RadioButton = ({ hideToggles = false, showLabel = true, ...props }: RadioButtonProps) => (
  <div
    key={props.value}
    className={classNames("radio_button item", props.className, {
      active: props.isChecked,
      disabled: props.isDisabled,
      no_toggles: hideToggles
    })}
    onClick={(e) => {
      e.preventDefault(); // NOTE: w/o fires twice :/

      props.onChange && props.onChange(props.value);
    }}
    style={props.style}
  >
    <label>
      <input
        type="radio"
        name={props.name}
        className={classnames("radio", { checked: props.isChecked })} // note: we won't use checked pseudo selector in css, cause it may cause conflicts with RDG with same items names, e.g. responsive
        checked={props.isChecked}
        onChange={identity} // required by React
        readOnly={props.isDisabled}
        value={props.value}
      />
      <div className="radio_button_mark"></div>
      {!!props.label && showLabel && <span className="radio_label" dangerouslySetInnerHTML={{ __html: props.label }} />}
      {props.image ? (
        props.ImageComponent ? (
          <props.ImageComponent src={props.image} />
        ) : (
          <img src={props.image} />
        )
      ) : null}
    </label>

    {!!props.addon && <div className="addon">{props.addon}</div>}
  </div>
);

export default RadioButton;
